<template>
  <div v-if="isOpen" class="fixed z-50 left-0 top-0 justify-center items-center w-screen h-screen bg-black-transparent">
    <div class="flex justify-center items-center w-screen h-screen">
      <div class="w-screen sm:w-screen md:w-1/3 p-12">
        <div class="bg-white p-12 rounded-lg">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Vue, Component } from 'vue-property-decorator'

@Component
export default class Modal extends Vue {
  isOpen = false
}
</script>
